import Vue from 'vue';
import Router from 'vue-router';
import Chat from '@/views/chat/Chat.vue';
import Top from '@/views/top/Top.vue';
import Dummy from '@/views/dummy/Dummy.vue';

Vue.use(Router);

export const routes = [
  { path: '/*', name: 'Chat', component: Chat },

  // { path: '/chat', name: 'Chat', component: Chat },
  // { path: '/*', name: 'Top', component: Top },
]

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});
